import { render } from "./vsphere-volume.vue?vue&type=template&id=c3ffbe9e"
import script from "./vsphere-volume.vue?vue&type=script&lang=js"
export * from "./vsphere-volume.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__